import React, { useMemo, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash } from '@fortawesome/pro-regular-svg-icons/faTrash'
import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons/faExclamationTriangle'

import { HydraTable, TextFilter, Modal } from '@peracto/peracto-ui'

import { GET_LIST, useClient } from '@peracto/client'

const ArticleAssignmentList = ({ articleCategory, onDelete }) => {
    const [showDeleteDialog, setShowDeleteDialog] = useState(false)
    const [itemToDelete, setItemToDelete] = useState(false)

    const { client } = useClient()

    // The 'selectable' property is used to define if the
    // column is available in the 'manage columns' dropdown
    const columns = useMemo(() => [
        {
            Header: 'Name',
            id: 'article.name',
            Filter: props => <TextFilter label="Name" {...props} />,
            Cell: ({ row: { original } }) => original?.article?.name || '-',
            selectable: false,
        },
        {
            Header: 'Title',
            id: 'title',
            Cell: ({ row: { original } }) => original?.article?.title || '-',
            selectable: false,
        },

        {
            Header: 'Delete',
            id: 'delete',
            sortType: 'basic',
            Cell: row => (
                <button
                    className="btn btn-danger"
                    data-testid={`row-${row.row.index}-remove`}
                    onClick={() => {
                        setItemToDelete(row.row.original)
                        setShowDeleteDialog(true)
                    }}
                >
                    <FontAwesomeIcon icon={faTrash} />
                </button>
            ),
            selectable: false,
        },
    ])

    const onFetchData = options => client(GET_LIST, 'article-category-links', options)

    return (
        <div className="row">
            <div className="col">
                <HydraTable
                    columns={columns}
                    onFetchData={onFetchData}
                    defaultFilters={{
                        'article.name': '',
                        'article.title': '',
                    }}
                    alwaysFilter={{ articleCategory: articleCategory.id }}
                    showFilterToggle={false}
                />

                <Modal
                    isVisible={showDeleteDialog}
                    title="Delete Article Link"
                    close={() => setShowDeleteDialog(false)}
                    buttons={[
                        {
                            type: 'btn-outline-secondary',
                            text: 'Close',
                            action: () => {
                                setShowDeleteDialog(false)
                            },
                        },
                        {
                            type: 'btn-danger',
                            text: 'Delete',
                            action: () => {
                                setShowDeleteDialog(false)
                                onDelete(itemToDelete.id)
                            },
                        },
                    ]}
                >
                    <FontAwesomeIcon
                        icon={faExclamationTriangle}
                        size="4x"
                        className="!block !mb-6"
                    />
                    Are you sure you would like to remove{' '}
                    {itemToDelete?.article?.name ? itemToDelete.article.name : 'this article'} from
                    this category?
                </Modal>
            </div>
        </div>
    )
}

export default ArticleAssignmentList
